"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderModeReducers = void 0;
var setRenderMode = function (state, action) {
    state.renderMode = action.payload;
};
var setEditRenderMode = function (state) {
    state.renderMode = "edit";
};
var setViewRenderMode = function (state) {
    state.renderMode = "view";
};
exports.renderModeReducers = {
    setRenderMode: setRenderMode,
    setEditRenderMode: setEditRenderMode,
    setViewRenderMode: setViewRenderMode,
};
//# sourceMappingURL=renderModeReducers.js.map